export default __webpack_public_path__ + "static/media/Group1015.fc9b2cec.svg";